import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import {
	MatFormField,
	MatLabel,
	MatInput,
	MatSuffix,
	MatError,
} from '@angular/material/input';
import { NgxMaskDirective } from 'ngx-mask';
import { ReactiveFormsModule } from '@angular/forms';
import { MatIcon } from '@angular/material/icon';
import { NgIf } from '@angular/common';

@Component({
	selector: 'formly-phone-input',
	template: `
		<mat-form-field appearance="outline" style="width: 100%">
			<mat-label>{{ props.label }}</mat-label>
			<input
				matInput
				[formControl]="formControl"
				[formlyAttributes]="field"
				[required]="props.required"
				mask="(000) 000-0000"
				[placeholder]="props.placeholder || ''"
				type="tel"
			/>
			<mat-icon role="button" class="phone" matSuffix (click)="telCall()"
				>phone</mat-icon
			>
			<mat-error *ngIf="formControl.invalid && formControl.touched">
				<formly-validation-message [field]="field"></formly-validation-message>
			</mat-error>
		</mat-form-field>
	`,
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./phone-input.type.scss'],
	imports: [
		MatFormField,
		MatLabel,
		MatInput,
		NgxMaskDirective,
		ReactiveFormsModule,
		FormlyModule,
		MatIcon,
		MatSuffix,
		NgIf,
		MatError,
	],
})
export class PhoneInputType extends FieldType<FieldTypeConfig> {
	telCall(): void {
		window.open(`tel:${this.formControl.value}`, '_self');
	}
}
